import InfoList from "../components/InfoList";
import { Helmet } from "react-helmet";
import { useT } from "../hooks/useLang";

const titleStyle = {
  fontFamily: "var(--font-display)",
  color: "#E0392B",
  fontSize: "clamp(2rem, 5vw, 3rem)",
  WebkitTextStroke: "1.5px var(--ink)",
  textShadow: "3px 3px 0 var(--ink)",
  lineHeight: 1.05,
  marginBottom: "2.5rem",
};

export default function News() {
  const t = useT();

  return (
    <div className="min-h-screen pb-16" style={{ background: "var(--bg)", paddingTop: "10px" }}>
      <Helmet>
        <title>Starting Five - Accueil</title>
        <meta name="description" content="Starting Five, groupe togolais proposant des services innovants pour simplifier votre quotidien." />
      </Helmet>

      {/* Zigzag juste sous la navbar */}
      <div className="zigzag-band" />

      <div className="max-w-4xl mx-auto px-6 pt-16">
        <span className="eyebrow">{t("actualites")}</span>
        <h1 style={titleStyle}>{t("newsTitle")}</h1>
        <div className="brut-card p-6 md:p-8">
          <InfoList readOnly={true} />
        </div>
      </div>
    </div>
  );
}